module.exports = __webpack_public_path__ + "img/login-staff.4df3d562.jpg";